import { render, staticRenderFns } from "./SalesDocuments.vue?vue&type=template&id=174dc414&scoped=true"
import script from "./SalesDocuments.vue?vue&type=script&lang=js"
export * from "./SalesDocuments.vue?vue&type=script&lang=js"
import style0 from "./SalesDocuments.vue?vue&type=style&index=0&id=174dc414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174dc414",
  null
  
)

export default component.exports